var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "clearfix main_center" }, [
    _c("div", { staticClass: "top-content" }, [
      _c(
        "div",
        { staticClass: "left-navbar" },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.backBtn } },
            [_vm._v("返回")]
          ),
          _vm.hasBtnPermission("btn_jz_pm_dgwitness_guard_config_add")
            ? _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: { type: "primary", size: "small", plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.routerEdit()
                    },
                  },
                },
                [_vm._v("编辑")]
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "right-content" },
      [
        _c(
          "el-form",
          {
            ref: "form",
            staticClass: "form viewFormWrapper",
            attrs: { model: _vm.form, "label-width": "150px" },
          },
          [
            _c(
              "el-card",
              {
                staticClass: "box-card",
                staticStyle: { "margin-bottom": "0px" },
                style: { height: _vm.cardHight },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [_c("span", [_vm._v("配置信息")])]
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("el-form-item", { attrs: { label: "名称：" } }, [
                          _c("span", [_vm._v(_vm._s(_vm.form.name))]),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("el-form-item", { attrs: { label: "流id：" } }, [
                          _c("span", [_vm._v(_vm._s(_vm.form.streamId))]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "流媒体地址：" } },
                          [_c("span", [_vm._v(_vm._s(_vm.form.streamUrl))])]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("el-form-item", { attrs: { label: "所在楼层：" } }, [
                          _c("span", [_vm._v(_vm._s(_vm.form.locationName))]),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "所属交易中心：" } },
                          [_c("span", [_vm._v(_vm._s(_vm.form.tradeOrgName))])]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("el-form-item", { attrs: { label: "发布标记：" } }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.form.pubFlag == 0 ? "未发布" : "已发布"
                              )
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }